<app-error-modal [error]="error$ | async" (closeModal)="closeModal()"></app-error-modal>

<app-change-password></app-change-password>

<nav class="navbar has-shadow">
  <div class="container is-fluid">
    <div class="navbar-brand is-large marginL">
      <a href="/" class="navbar-item">
        <img src="/assets/img/tp-travel.png" alt="Tp Travel" />
      </a>
    </div>
    <div
      class="penalties-container"
      *ngIf="{
        isAirline: isAirline,
        penaltiesAdditional: penaltiesAdditional$ | async,
        overridesState: overridesState$ | async,
        option: option$ | async,
        currencies: currencies$ | async,
        pnrInfo: pnrInfo$ | async
      } as data"
    >
      <app-edit-penalties
        *ngIf="!isDashboard"
        [readOnly]="true"
        [showDetails]="true"
        [loading]="data.overridesState?.loading"
        [close]="data.overridesState?.changePenalties"
        [state]="data.option?.exchangeFare?.exchangeFareOverride?.penaltiesState"
        [currencies]="data.currencies"
        [penalties]="data.option?.exchangeFare?.penalties"
        [passenger]="data.pnrInfo?.passengers"
        [additionalPenalties]="data.penaltiesAdditional"
        (savePenalties)="savePenalties($event)"
        edit-penalty
      ></app-edit-penalties>
    </div>

    <div class="navbar-menu paddingR">
      <div class="navbar-end">
        <div class="navbar-item has-dropdown">
          <div
            class="manual-container"
            *ngIf="(manualInfo$ | async) && (manualInfo$ | async).length > 0"
          >
            <a (click)="showManual()" target="_blank">
              <mat-icon matTooltip="{{ 'manuals.tooltip' | translate }}">book</mat-icon>
            </a>
          </div>

          <div class="is-vcentered is-grouped-centered divLanguage select is-fullwidth marginR">
            <select (change)="ChangeValue($event)">
              <option
                *ngFor="let item of actionLanguage"
                [selected]="item.code === currentLanguage"
                [value]="item.code"
              >
                {{ item.name | translate }}
              </option>
            </select>
          </div>

          <div class="dropdown is-hoverable">
            <div class="dropdown-trigger is-vcentered is-grouped-centered">
              <a class="" aria-haspopup="true" aria-controls="dropdown-menu4">
                <div class="columns is-vcentered is-centered">
                  <div class="column is-narrow">
                    <span class="icon">
                      <em class="mdi mdi-account-circle mdi-24px" aria-hidden="true"></em>
                    </span>
                  </div>

                  <div
                    class="column is-narrow is-centered has-text-black weight-medium no-padding-left"
                    *ngIf="user$ | async as user"
                  >
                    <span>{{ user.firstName | firstcase }}&nbsp;</span>
                    <span>{{ user.lastName | firstcase }}</span>
                  </div>

                  <div class="column is-narrow no-padding-left">
                    <span class="icon">
                      <em class="mdi mdi-chevron-down mdi-24px" aria-hidden="true"></em>
                    </span>
                  </div>
                </div>
              </a>
            </div>

            <div
              [ngClass]="{
                'dropdown-menu-responsive': !(user$ | async),
                'dropdown-menu': true
              }"
              id="dropdown-menu4"
              role="menu"
            >
              <div class="dropdown-content">
                <div
                  *ngIf="isAirline && isCredentialsActive && showUpdateCredentialsButton"
                  class="dropdown-item"
                >
                  <a class="is-link" (click)="toggleBookingCredentialsModal()">
                    <span class="icon is-large">
                      <em class="mdi mdi-lock-reset mdi-18px"></em>
                    </span>
                    <span> {{ 'booking-credentials.update' | translate }} </span>
                  </a>
                </div>

                <div class="dropdown-item">
                  <a class="is-link" (click)="logout()" [routerLink]="['/']">
                    <span class="icon is-large">
                      <em class="mdi mdi-door-open mdi-18px"></em>
                    </span>
                    <span> {{ 'shared.close-session' | translate }} </span>
                  </a>
                </div>
                <div class="dropdown-item" style="padding-top: 4px; padding-bottom: 4px; border-top: 1px solid #ededed;">
                  <span style="font-size: 0.7rem; color: #aaa;">v1.2026.6.3</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>

<app-modal
  [isActive]="showCredentialsModal"
  [showCloseFooter]="false"
  [showClose]="false"
  [closeOnEsc]="environmentValidation()"
  (modalState)="toggleBookingCredentialsModal()"
  (acceptState)="handleCredentialsAccept()"
  (onPressEsc)="pressEscOnCredentialsModal()"
>
  <p class="modal-card-title" modal-title>
    {{ 'booking-credentials.title' | translate }}
  </p>

  <div class="has-text-grey" modal-content>
    <div
      *ngIf="
        bookingCredentialsState.loginStatus.isLoggedIn &&
        !bookingCredentialsState.loginStatus.isLoading
      "
    >
      <app-alert type="success">
        <div description>
          {{ 'booking-credentials.login-success' | translate }}
        </div>
      </app-alert>

      <div class="v-separator"></div>
    </div>

    <div
      *ngIf="
        bookingCredentialsState.loginStatus.isError &&
        !bookingCredentialsState.loginStatus.isLoggedIn
      "
    >
      <app-alert type="error">
        <div description>
          {{ 'booking-credentials.login-error' | translate }}
        </div>
      </app-alert>

      <div class="v-separator"></div>
    </div>

    <app-booking-credentials
      [formDisabled]="disableCredentialsForm"
      (formReady)="validateCredentialsForm($event)"
      (credentialsData)="saveCredentialsData($event)"
    ></app-booking-credentials>

    <br />
    <br />

    <div class="footer-buttons">
      <div class="left-section">
        <span
          *ngIf="
            (bookingCredentialsState.loginStatus.isLoggedIn ||
              bookingCredentialsState.loginStatus.isError) &&
            !bookingCredentialsState.loginStatus.isLoading
          "
          class="ml-3"
          >{{ bookingCredentialsState.loginStatus.loginResponse }}</span
        >
      </div>

      <div class="right-section">
        <div
          *ngIf="
            !bookingCredentialsState.loginStatus.isLoggedIn &&
            !bookingCredentialsState.loginStatus.isLoading
          "
          class="mr-3"
          style="justify-self: flex-end"
        >
          <app-input-submit
            inputText="{{ 'shared.log-in' | translate }}"
            type="submit"
            [disabled]="!bookingCredentialsReady"
            [isSuccess]="true"
            (clickButton)="EPRLogin()"
          ></app-input-submit>
        </div>

        <div *ngIf="bookingCredentialsState.loginStatus.isLoading" class="mr-3">
          <app-input-submit
            type="submit"
            [disabled]="true"
            [isSuccess]="true"
            [isLoading]="true"
            (clickButton)="(null)"
          ></app-input-submit>
        </div>

        <div
          *ngIf="
            bookingCredentialsState.loginStatus.isLoggedIn &&
            !bookingCredentialsState.loginStatus.isLoading
          "
          class="mr-3"
        >
          <app-input-submit
            inputText="{{ 'shared.save-and-exit' | translate }}"
            type="submit"
            [isSuccess]="true"
            (clickButton)="handleCredentialsAccept()"
          ></app-input-submit>
        </div>
      </div>
    </div>

    <span *ngIf="showCredentialsRequiredText" class="weight-medium is-size-6 text-color">{{
      'booking-credentials.form-required' | translate
    }}</span>
  </div>
</app-modal>
